<template>
  <!-- MODAL NOVIDADES LANDINGPAGE -->
  <b-modal
    class="modal-lp"
    no-close-on-backdrop
    no-close-on-esc
    @hide="validarExibirLP(false)"
    ref="modalLP"
    hide-footer
    id="modalLP"
    header-class="modal-lp-header modal-eraser-header"
    body-class="modal-lp-body"
    footer-class="modal-lp-footer"
  >
    <div slot="modal-header" class="title-area">
      <div class="header">
        <img @click="validarExibirLP(false)" src="@/assets/images/modalLP/fecha.png" />
        <button class="icon-voltar" v-if="modo === 'video'" @click="setModo('funcionalidades')">
          <font-awesome-icon icon="arrow-left" />
        </button>
      </div>
    </div>

    <!-- <div class="row">
            <div v-for="f in funcionalidades" class="col-4 text-center" :key="f.icone">
                <div :class="(funcionalidadeSelecionada.nome == f.nome) ? 'funcionalidade selecionado' : 'funcionalidade'" @click="selecionarFuncionalidade(f)">
                <img :src="getImg('modalLP/'+f.icone)" />
                <span>{{f.nome}} </span>
                </div>
            </div>
        </div> -->
    <div class="modal-content-video" v-if="modo === 'video'">
      <iframe
        width="600"
        height="415"
        src="https://www.youtube.com/embed/7u92RTekTb4?mute=1"
        frameborder="0"
      ></iframe>
    </div>
    <div class="modal-content-func" v-if="modo === 'funcionalidades'">
      <div class="line1" v-if="loading">
        <FuncionalidadeSkeleton type="default" />
        <FuncionalidadeSkeleton type="large" />
        <FuncionalidadeSkeleton type="default" />
      </div>

      <div class="line2" v-if="loading">
        <FuncionalidadeSkeleton type="default" />
        <FuncionalidadeSkeleton type="default" />
        <FuncionalidadeSkeleton type="default" />
        <FuncionalidadeSkeleton type="default" />
      </div>

      <div class="line1" v-if="!loading">
        <Funcionalidade type="default" :item="f[0]" />
        <Funcionalidade type="large" :item="{ nome: '', icone: '' }" />
        <Funcionalidade type="default" :item="f[1]" />
      </div>

      <div class="line2" v-if="!loading">
        <Funcionalidade type="default" :item="f[2]" />
        <Funcionalidade type="default" :item="f[3]" />
        <Funcionalidade type="default" :item="f[4]" />
        <Funcionalidade type="default" :item="f[5]" />
      </div>

      <div class="caixa">
        <span class="titulo">
          {{ selecionado.nome }}
        </span>
        {{ selecionado.texto }}
      </div>
    </div>
    <div class="modal-footer">
      <span @click="validarExibirLP(true)">
        Não exibir novamente
      </span>
    </div>
  </b-modal>
</template>

<script>
import Funcionalidade from "./components/Funcionalidade.vue";
import FuncionalidadeSkeleton from "./components/FuncionalidadeSkeleton.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "ModalFuncionalidades",
  components: {
    Funcionalidade,
    FuncionalidadeSkeleton
  },
  props: [],
  data() {
    return {
      loading: true
    };
  },

  created() {
    this.$bus.$on("showModalLP", status => {
      this.exibirLP(true);
    });
  },

  mounted() {
    this.buscaFuncionalidades();
    this.exibirLP(this.blExibeLp);
  },

  computed: {
    ...mapGetters("modalFuncionalidades", {
      f: "getFuncionalidades",
      blExibeLp: "getBlExibeLp",
      selecionado: "getSelecionado",
      modo: "getModo"
    })
  },
  methods: {
    ...mapActions("modalFuncionalidades", [
      "buscaFuncionalidades",
      "updateNaoExibirLp",
      "setSelecionado",
      "setBlExibeLp",
      "setModo"
    ]),
    validarExibirLP: function(naoExibir) {
      this.setBlExibeLp(0);
      this.setModo("funcionalidades");
      this.$refs.modalLP.hide();

      if (naoExibir) {
        localStorage.setItem("verificarLP", false);
        this.updateNaoExibirLp();
      }
    },
    exibirLP(status) {
      if (status) {
        this.$refs.modalLP.show();
      }
    }
  },
  watch: {
    f: function() {
      if (this.f.length > 0) {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="sass">
@import "./ModalFuncionalidades.scss"
</style>
